
<template>
<div>
  <div v-if="!isLoading" class="">
    <div v-if="item" class="">
      <div class="row mb-5">
        <div class="col-12"> 
          <div class="card mb-5">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">Training Enrollment details</h5>
              <div class="dropdown dropstart no-arrow">
                <button class="dropdown-toggle btn btn-sm btn-light" type="button"
                  role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="ri-more-2-fill"></i>
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <button @click="generateSlip()" class="dropdown-item"
                    type="button" >
                    Print training slip</button>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-body position-relative">
              <div  class="row g-4"> 
                <div class="col-sm-6">
                  <label class="small text-muted">Status</label>
                  <p class="mb-0"><span v-html="statusBadge(item.status)"></span></p>
                </div>
                <div class="col-sm-6">
                  <label class="small text-muted">Enrolled on</label>
                  <p class="mb-0">{{ $filters.date(item.created_at,1) }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="bd-callout mt-0 mb-5 bd-callout-info">
            <h4>Your Training Slip. </h4>
            <div class="pt-4">
              <p class="mb-1">
                You can download this training slip and present it to your employer as proof and for taking attendance. 
              </p>
              <div class="mt-3">
                <button @click="generateSlip()" class="btn btn-primary"  type="button" >Print training slip</button>
              </div>
            </div>
          </div>
          <div v-if="item.program" class="card mb-5 overflow-hidden">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">Training Program Details</h5>
            </div>
            <div class="card-body">
              <div class="row g-3 g-lg-4">
                <div class="col-lg-6">
                  <label class="small text-muted">Program ID</label>
                  <p class="mb-0">{{ item.program.friendly_id }}</p>
                </div>
                <div class="col-lg-6">
                  <label class="small text-muted">Title</label>
                  <p class="mb-0">{{item.program.title}}</p>
                </div>
                <div class="col-lg-6">
                  <label class="small text-muted">Contact Phone Number</label>
                  <p class="mb-0">{{item.program.mobile}}</p>
                </div>
                <div class="col-lg-6">
                  <label class="small text-muted">Contact Email</label>
                  <p class="mb-0">{{item.program.email}}</p>
                </div>
                <div class="col-sm-6">
                  <label class="small text-muted">Training Duration</label>
                  <p class="mb-0"> {{ $filters.formatDuration(item.program.duration_in_days) }} </p>
                </div>
                <div class="col-sm-6">
                  <label class="mb-0 text-muted">Scheduled Date and Time</label>
                  <p class="mb-0 mt-2 pt-1">{{ $filters.formatSchedulePeriod(item.program.start_date, item.program.end_date) }}</p>
                </div>
                <div class="col-sm-6">
                  <label class="small text-muted">Location/Venue </label>
                  <CommonAddress :item="item.program" />
                </div>
                <div v-if="item.program.canceled_at" class="col-sm-6">
                  <label class="mb-0 text-muted">Canceled at</label>
                  <p class="mb-0 mt-2 pt-1 text-muted">{{ $filters.date(item.program.canceled_at, 1) }}</p>
                </div>
                <div class="col-12">
                  <label class="small text-muted">Description</label>
                  <div v-html="preText(item.program.description)" class="mb-0"></div>
                </div>
              </div>          
            </div>
          </div>
          <div v-if="item.opportunity">
            <opportunity-detail-card  :item="item.opportunity" />
          </div>
        </div>
      </div>
      <div class="row gy-2">
        <div class="col-12">
          <training-attendances :enrollment="item"/>
        </div>
      </div>
    </div>
  </div>
  <is-loading v-else />
</div>
</template>

<script>
import IsLoading from '@/components/IsLoading.vue'
import OpportunityDetailCard from '@/components/cards/OpportunityDetailCard.vue'
import TrainingAttendances from './TrainingAttendances.vue';

export default {
  name: "training-program-show",
  components:{
    IsLoading,
    OpportunityDetailCard,
    TrainingAttendances
  },
  data() {
    return {
      isLoading: true,
      popupModalShow: false,
      item: null,
    }
  },
  watch: {
    '$route.params.enrollmentId': function (id){
      if(id) this.fetchItem()
    },
  },
  methods: {
    updateItem(item){
      this.item = Object.assign(this.item, item);
    },
    fetchItem(){
      this.isLoading = true
      this.$http.get(`/training-enrollments/${this.$route.params.enrollmentId}/show`)
      .then((response) => {
        this.isLoading = false
        if(response.data.success){
          this.item = response.data.data
        }else{
          this.$router.push({path: '/error-404'})
        }
      })
    },
    generateSlip(){
      const payload = {
        url: `/training-enrollments/${this.item.id}/slip`,
        data: {}
      }
      this.$store.dispatch("changeLoaderValue", true)
      this.pdfFileExport(payload)
        .then((response) => {
          this.$store.dispatch("changeLoaderValue", false)
        }).catch((error) => {
          this.$store.dispatch("changeLoaderValue", false)
        })
    },
    initializeAll(){
      this.popupModalShow = false;
    }
  },
  created(){
    this.fetchItem()
  },
}

</script>

